export const medicalPshychologyConst = {
  path: "/single-programs/medical-pshychology",
  title: "ФАКУЛЬТЕТ МЕДИЦИНЫ – МЕДИЦИНСКАЯ ПСИХОЛОГИЯ",
  contentJSX: (
    <>
      <p>
        <strong>Диплом:</strong> магистра
      </p>
      <p>
        <strong>Форма обучения:</strong> очная или дистанционная
      </p>
      <p>
        <strong>Форма связи:</strong> получить консультацию приемной комиссии
      </p>
      <h2>Медицинская психология — понимать, чтобы помогать</h2>
      <p>
        <strong>Медицинская психология</strong> — это уникальное направление на стыке психологии и медицины. Оно направлено на изучение
        психологических аспектов здоровья, поведения пациентов, их реакции на болезнь, а также взаимодействия между врачом и пациентом.
      </p>
      <p>
        Программа готовит профессионалов, способных глубоко понимать внутренние процессы, влияющие на физическое и психическое состояние
        человека. Особое внимание уделяется психосоматике, клинической психодиагностике, сопровождению пациентов с хроническими
        заболеваниями, онкологическими и психиатрическими расстройствами.
      </p>
      <p>
        Мы обучаем будущих специалистов, которые смогут эффективно работать в медицинских учреждениях, участвовать в мультидисциплинарных
        командах и обеспечивать психологическую поддержку пациентам на всех этапах лечения.
      </p>
      <h2>Что вы будете изучать?</h2>
      <ul>
        <li>Психология болезни и кризисных состояний</li>
        <li>Медицинская и клиническая психология</li>
        <li>Психосоматика</li>
        <li>Основы психиатрии и неврологии</li>
        <li>Этические и правовые аспекты в медицине</li>
        <li>Коммуникация в клинической практике</li>
        <li>Методы психотерапии и консультирования</li>
        <li>Психологическая диагностика и интервенции</li>
        <li>Работа с родственниками и пациентами в острых состояниях</li>
      </ul>
      <p>
        Программа включает в себя как академическую подготовку, так и практические занятия в больницах, реабилитационных центрах и клиниках.
        Студенты развивают навыки наблюдения, эмпатии, устойчивости к стрессу и этичного принятия решений.
      </p>
      <h2>Кем можно работать после окончания?</h2>
      <ul>
        <li>Медицинский психолог в клиниках и стационарах</li>
        <li>Психолог-консультант в онкологических и реабилитационных центрах</li>
        <li>Специалист по психосоматике</li>
        <li>Психолог в хосписе или паллиативной службе</li>
        <li>Психолог в отделениях интенсивной терапии</li>
        <li>Научный сотрудник или преподаватель</li>
      </ul>
      <h2>Средний доход специалистов в Европе:</h2>
      <p>
        от <strong>€40,000 до €80,000 в год,</strong> в зависимости от сферы, опыта и страны
      </p>
      <h2>Почему выбирают нас?</h2>
      <ul>
        <li>Европейский диплом, признанный в странах ЕС</li>
        <li>Индивидуальный подход к каждому студенту</li>
        <li>Возможность дистанционного обучения без потери качества</li>
        <li>Преподаватели-практики из клиник Европы</li>
        <li>Доступ к симуляционным программам и психодиагностическим инструментам</li>
        <li>Практика в европейских клиниках и реабилитационных центрах</li>
        <li>Поддержка в трудоустройстве и карьерном росте</li>
      </ul>
      <p>
        Учитесь помогать людям справляться с самыми сложными состояниями — осознанно, профессионально и с научной опорой. Медицинская
        психология — профессия будущего, где знания и эмпатия идут рука об руку.
      </p>
      <h2>Как поступить?</h2>
    </>
  ),
  contentSearch: `
    Диплом: магистра
    Формы обучения: очная или дистанционная
    Форма связи: Получить консультацию приемной комиссии
    Медицинская психология — понимать, чтобы помогать
    Медицинская психология — это уникальное направление на стыке психологии и медицины. Оно направлено на изучение психологических аспектов здоровья, поведения пациентов, их реакции на болезнь, а также взаимодействия между врачом и пациентом.
    Программа готовит профессионалов, способных глубоко понимать внутренние процессы, влияющие на физическое и психическое состояние человека. Особое внимание уделяется психосоматике, клинической психодиагностике, сопровождению пациентов с хроническими заболеваниями, онкологическими и психиатрическими расстройствами.
    Мы обучаем будущих специалистов, которые смогут эффективно работать в медицинских учреждениях, участвовать в мультидисциплинарных командах и обеспечивать психологическую поддержку пациентам на всех этапах лечения.

    Что вы будете изучать?
    • Психология болезни и кризисных состояний
    • Медицинская и клиническая психология
    • Психосоматика
    • Основы психиатрии и неврологии
    • Этические и правовые аспекты в медицине
    • Коммуникация в клинической практике
    • Методы психотерапии и консультирования
    • Психологическая диагностика и интервенции
    • Работа с родственниками и пациентами в острых состояниях
    Программа включает в себя как академическую подготовку, так и практические занятия в больницах, реабилитационных центрах и клиниках. Студенты развивают навыки наблюдения, эмпатии, устойчивости к стрессу и этичного принятия решений.

    Кем можно работать после окончания?
    • Медицинский психолог в клиниках и стационарах
    • Психолог-консультант в онкологических и реабилитационных центрах
    • Специалист по психосоматике
    • Психолог в хосписе или паллиативной службе
    • Психолог в отделениях интенсивной терапии
    • Научный сотрудник или преподаватель

    Средний доход специалистов в Европе:
    от €40,000 до €80,000 в год, в зависимости от сферы, опыта и страны

    Почему выбирают нас?
    • Европейский диплом, признанный в странах ЕС
    • Индивидуальный подход к каждому студенту
    • Возможность дистанционного обучения без потери качества
    • Преподаватели-практики из клиник Европы
    • Доступ к симуляционным программам и психодиагностическим инструментам
    • Практика в европейских клиниках и реабилитационных центрах
    • Поддержка в трудоустройстве и карьерном росте

    Учитесь помогать людям справляться с самыми сложными состояниями — осознанно, профессионально и с научной опорой. Медицинская психология — профессия будущего, где знания и эмпатия идут рука об руку.

    Как поступить?
  `,
};
